import {
  makeColorSchema
} from "./chunk-SNUDSNGS.js";
import "./chunk-EUXUH3YW.js";

// libs/core/src/lib/theme/themes/brand-color-schemes/community.style.ts
var communityStyle = makeColorSchema("#00a0b5");
export {
  communityStyle
};
//# sourceMappingURL=community.style-RWKB44BC.js.map
